<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <h4>Houses</h4>
          <div class="scrollable-table table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
                <tr>
                  <th>Sl</th>
                  <th>Ses Name</th>
                  <th>Father's/Husband's Name</th>
                  <th>Mother's Name</th>
                  <th>Mouza</th>
                  <th>Centre Name</th>
                  <th>House Type</th>
                  <th>House No</th>
                  <th>Handover Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in houses" :key="index">
                  <td>{{ index + 1 }}</td>
                  <td>{{item.ses.name}}</td>
                  <td>{{item.ses.father_husband_name}}</td>
                  <td>{{item.ses.mother_name}}</td>
                  <td>{{item.ses.mouza.desc}}</td>
                  <td>{{item.package.centre_name}}</td>
                  <td>{{item.house_type.desc}}</td>
                  <td>{{item.house_no}}</td>
                  <td>{{item.handover_date}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import http from '@state/http'

export default {
  page: {
    title: 'House Report Package',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'House Report Package',
      items: [
        {
          text: 'Dashboard',
          href: '/',
        },
        {
          text: 'Land',
          active: true,
        },
      ],
      houses: [],
    }
  },
  mounted() {
    this.packagesReport()
  },
  methods: {
    packagesReport() {
      http.get(`api/ses/report/centre-of-resettlement/houses/${this.$route.params.package_id}`).then((response) => {
          console.log(response.data)
          this.houses = response.data
      })
    },
  }
}
</script>
